var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSideBurgerRequests(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4993 7.21453V13.5001C22.4993 15.0715 21.9755 16.381 21.0536 17.3028C20.1421 18.2143 18.8326 18.738 17.2612 18.738V20.9694C17.2612 21.8075 16.3288 22.3104 15.6374 21.8494L10.9755 18.738H8.75451C8.83832 18.4238 8.88022 18.099 8.88022 17.7638C8.88022 16.6952 8.47164 15.7105 7.80117 14.9667C7.04688 14.1077 5.92593 13.5734 4.68974 13.5734C3.5164 13.5734 2.44783 14.0553 1.68307 14.841C1.58878 14.422 1.54688 13.9715 1.54688 13.5001V7.21453C1.54688 4.07175 3.64212 1.97656 6.78498 1.97656H17.2612C20.404 1.97656 22.4993 4.07175 22.4993 7.21453Z",
    stroke: "white",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88096 17.7607C8.88096 18.0959 8.83906 18.4207 8.75525 18.7349C8.66097 19.154 8.49336 19.5625 8.27335 19.9187C7.5505 21.1339 6.22001 21.9511 4.69048 21.9511C3.61143 21.9511 2.63714 21.5425 1.90381 20.872C1.58952 20.5996 1.31713 20.2749 1.10761 19.9187C0.719986 19.2902 0.5 18.5464 0.5 17.7607C0.5 16.6293 0.950482 15.5922 1.68382 14.8379C2.44858 14.0522 3.51715 13.5703 4.69048 13.5703C5.92667 13.5703 7.04763 14.1046 7.80191 14.9636C8.47239 15.7074 8.88096 16.6921 8.88096 17.7607Z",
    stroke: "white",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.24689 17.7422H3.125",
    stroke: "white",
    strokeWidth: 0.838085,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6875 16.2109V19.3432",
    stroke: "white",
    strokeWidth: 0.838085,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.53516 8.40625H16.5148",
    stroke: "white",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.53516 10.6562H16.5148",
    stroke: "white",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideBurgerRequests);
export default __webpack_public_path__ + "static/media/SideBurgerRequests.fb152aa77dd1e37b003d5d29be6fd8a8.svg";
export { ForwardRef as ReactComponent };